import { gql } from "@apollo/client";
import { API } from "../API";
import axiosInstance from "api/axiosInstance";
import { ILastTwoShiftsEventsResponse } from "components/HMIUptimeDowntimeBar/HMIUptimeDowntimeBarInterfaces";
import {
    ILastTwoShiftsEventsByMachineCenter,
    ILastTwoShiftsMachineCentersInfoByMill,
} from "entities/LiveDowntimeReportEntity/LiveDowntimeReportEntityInterfaces";
import { Moment } from "moment";

const APIInstance = new API();

export const getLastTwoShiftsEvents = async (
    machine_center_id: number,
    nowMillTimezone?: Moment,
    includeOEE: boolean = false,
): Promise<ILastTwoShiftsEventsResponse> => {
    try {
        const now = nowMillTimezone ? nowMillTimezone?.utc() : new Date().toISOString();
        const url = `${APIInstance.api_root}/query/previous-and-current-shifts-machine-center-info-enhanced?machineCenterId=${machine_center_id}&date=${now}&includeOEE=${includeOEE}`;
        const response = await axiosInstance.get<ILastTwoShiftsEventsResponse>(url);

        return response as unknown as ILastTwoShiftsEventsResponse;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getLastTwoShiftsMachineCentersInfoByMill = async (
    millId: number,
    nowMillTimezone: Moment,
): Promise<ILastTwoShiftsMachineCentersInfoByMill> => {
    try {
        const url = `${
            APIInstance.api_root
        }/query/previous-and-current-shift-machine-centers-info-by-mill-enhanced?millId=${millId}&date=${nowMillTimezone.utc()}`;
        const response = await axiosInstance.get<ILastTwoShiftsMachineCentersInfoByMill>(url);

        return response as unknown as ILastTwoShiftsMachineCentersInfoByMill;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getLastTwoShiftsMachineCentersInfoByCluster = async (
    clusterId: number,
): Promise<ILastTwoShiftsEventsByMachineCenter[]> => {
    try {
        const now = new Date().toISOString();
        const url = `${APIInstance.api_root}/query/previous-and-current-shift-machine-centers-info-by-cluster-enhanced?clusterId=${clusterId}&date=${now}&includeOEE=true`;
        const response = await axiosInstance.get<ILastTwoShiftsMachineCentersInfoByMill>(url);

        return response?.data as unknown as ILastTwoShiftsEventsByMachineCenter[];
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export const getAllShifts = gql`
    query GetAllShifts {
        shift {
            shift_id
            name
            mill_id
        }
    }
`;
